import type { UnleashToggles } from 'shared/types';
import { createUnleash } from 'shared/unleash/hook';

export const defaultUnleashToggles: UnleashToggles = {
    hotjar: false,
};

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>(defaultUnleashToggles);

export { UnleashProvider, useUnleash };
